import { lazy } from 'react';

export const RequestsLazy = lazy(() => import('./Requests'));
